module.exports = __webpack_public_path__ + "img/Comorbidity_Thyroid.fcdb4e15.jpg";